import map from 'lodash/map'
import { BodyCell } from '../table-body/BodyCell'
import get from 'lodash/get'
import type { RenderDataBodyCellFunction } from '../types'
import { useTableContext } from '../Context'
import styles from '../datatable.module.scss'

export function useTableBody<T = any>(listItem: T, rowIndex: number) {
  const { listFields, onSelect, onRowDoubleClick, idFieldName = '_id', selectedItem, row } = useTableContext()
  let highlightClassName = ''

  const renderDataBodyCell: RenderDataBodyCellFunction = (fieldConfig, useTd) => {
    //we need to loop here for all list fields and render them using the HeaderCell
    return map(listFields, (listField) => {
      return (
        <BodyCell key={listField.name} field={listField} useTd={useTd}>
          {get(fieldConfig, listField.key, get(listItem, listField.name, null))}
        </BodyCell>
      )
    })
  }

  //if it is selectable then show the highlighting row class
  if (selectedItem && listItem) {
    if (selectedItem[idFieldName] === listItem[idFieldName] || listItem['_selected']) {
      highlightClassName = styles.selectedRow
    }
  }

  //the config that can be passed on the row
  const key = `${get(listItem, idFieldName, rowIndex)}_${rowIndex}`

  const item = {
    ...listItem,
    _highlightClassName: highlightClassName,
    _index: rowIndex,
    _renderDataBodyCell: null,
    _key: key,
    _fields: null,
  }

  //it uses hooks so we need ro run it like jsx
  const onRowClick = () => {
    if (onSelect) {
      onSelect(item)
    }
  }

  const _onRowDoubleClick = () => {
    if (onRowDoubleClick) onRowDoubleClick(item)
  }

  return {
    onRowClick,
    onRowDoubleClick: _onRowDoubleClick,
    highlightClassName,
    renderDataBodyCell,
    key,
    BodyRow: row,
  }
}
